import { render, staticRenderFns } from "./aiPhoto.vue?vue&type=template&id=58bcf4bd&scoped=true&"
import script from "./aiPhoto.vue?vue&type=script&lang=js&"
export * from "./aiPhoto.vue?vue&type=script&lang=js&"
import style0 from "./aiPhoto.vue?vue&type=style&index=0&id=58bcf4bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bcf4bd",
  null
  
)

export default component.exports